export default __webpack_public_path__ + "static/media/afb-color.2d535fee.svg";